import IconInfo from "app/components/Icon/components/IconInfo/IconInfo";
import { MarketsHelper } from "app/helpers/marketsHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { TranslationHelper } from "app/helpers/translationHelper";
import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";

type MarketTypeHeaderProps = {
  showMarketPeriodName?: boolean;
  showMarketQuarterName?: boolean;
  marketPeriod?: {
    marketPeriod: string;
  };
  marketType?: {
    marketType: string;
  };
  event?: {
    sportType: string;
  };
  homeTeam?: string;
  awayTeam?: string;
  intl: IntlShape;
  exchangeCommissionRate: number;
};

const MarketTypeHeader: React.FC<MarketTypeHeaderProps> = props => {
  const {
    intl,
    showMarketPeriodName,
    showMarketQuarterName,
    marketPeriod,
    marketType,
    event,
    homeTeam,
    awayTeam,
    exchangeCommissionRate,
  } = props;

  return (
    <div>
      <span className="collapsible-header_market-type">
        {(showMarketPeriodName || showMarketQuarterName) && marketPeriod && (
          <FormattedMessage
            tagName="span"
            id={TranslationHelper.getTranslationIdForMarket(
              marketPeriod.marketPeriod
            )}
          />
        )}{" "}
        {marketType && marketPeriod && event && (
          <FormattedMessage
            tagName="span"
            id={TranslationHelper.getTranslationIdForMarket(
              marketType.marketType,
              marketPeriod.marketPeriod,
              event.sportType
            )}
            values={{
              homeTeam: homeTeam,
              awayTeam: awayTeam,
            }}
          />
        )}{" "}
        {marketType &&
          marketPeriod &&
          event &&
          intl.formatMessage({
            id: TranslationHelper.getMarketNameSuffix(
              marketType.marketType,
              marketPeriod.marketPeriod,
              event.sportType
            ),
          })}
      </span>

      {marketType &&
        MarketsHelper.isMatchOdds(marketType.marketType) &&
        exchangeCommissionRate && (
          <span
            data-tip
            data-for={`commission`}
            data-type="light"
            data-effect="solid"
            data-place="top"
            data-background-color="white"
            data-padding="10px"
            data-text-color=""
            data-class={`react-tooltip__custom${
              SessionHelper.isAsianRouteAndSessionView() ? "__asian" : ""
            }`}
            data-border={true}
          >
            {
              <>
                <IconInfo className="exchange-header__icon" title="" />
                <ReactTooltip id={`commission`}>
                  <FormattedMessage
                    tagName="span"
                    id="reports-market-commission"
                    defaultMessage="Commission"
                  />
                  : {`${exchangeCommissionRate ? exchangeCommissionRate : ""}%`}
                </ReactTooltip>
              </>
            }
          </span>
        )}
    </div>
  );
};

const mapStateToProps = state => ({
  exchangeCommissionRate: state.userModel.user.exchangeCommissionRate,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MarketTypeHeader)) as any;
